import React from 'react';
import {Link} from 'react-router-dom';

const HEADER_LOGO_URL = 'https://media-manager-c.questera.ai/greta-media/d8c175ce79b3955ba0d8b96bda96a29c07cb99a231410859ff9e1eef6fbc458f258c6f3ecce2ad37a1ca0dd7574d37fa/images/aW1hZ2UvcG5n/656c9249b63b4af49011146f462f04da.png';

function Brand({light = false}) {
  return (
    <Link
      className={`brand ${light ? 'brand-light' : ''}`}
      to="/"
      aria-label="Cambia Digital home"
    >
      <img
        className="secondary-logo"
        src={HEADER_LOGO_URL}
        alt="Cambia Digital"
        style={{
          width: '170px',
          height: '58px',
          maxHeight: 'none',
          objectFit: 'cover',
          objectPosition: 'center'
        }}
      />
    </Link>
  );
}

export default Brand;